import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay"]
  static values = { open: Boolean }

  connect() {
    this.openValue = false
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove("hidden", "opacity-0", "translate-y-4")
      this.menuTarget.classList.add("opacity-100", "translate-y-0")
      this.overlayTarget.classList.remove("hidden")
      // Close when clicking outside
      document.addEventListener("click", this.handleOutsideClick)
    } else {
      this.menuTarget.classList.add("opacity-0", "translate-y-4")
      this.overlayTarget.classList.add("hidden")
      setTimeout(() => {
        if (!this.openValue) {
          this.menuTarget.classList.add("hidden")
        }
      }, 150)
      document.removeEventListener("click", this.handleOutsideClick)
    }
  }

  handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }
}
